module.exports = __webpack_public_path__ + "static/img/button_jieting_68px.56e71d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/button_jieting_68px.png
// module id = hNX/
// module chunks = 136